import { BadgeCheck, ShieldCheck, Users } from 'lucide-react'
import type { NavSection } from '../../core/router/navConfig'

/** Navegação da área Administrativo (24/10/2026): o que era a seção Geral do menu
 *  único, com Usuários e Cargos fora do hub de Cadastros, como itens próprios.
 *
 *  Desde 26/10/2026 ficam só Usuários, Cargos e Auditoria (Samuel: "deixar só a
 *  parte de cargos e usuários"). Os cadastros gerais e as Categorias voltaram para
 *  a Logística, e o acesso à área se decide pelo campo Áreas do Cargo.
 *
 *  Entrar no Administrativo não dá nenhum destes itens: cada um segue pedindo a
 *  própria key. Ver docs/areas/04-entrada-e-autorizacao.md. */
export const administrativoNav: NavSection[] = [
  {
    title: 'Administração',
    titleKey: 'nav.section.administration',
    items: [
      { label: 'Usuários', labelKey: 'nav.users', path: '/administrativo/usuarios', icon: Users, ready: true, matchNested: true, permission: 'users.view' },
      // O cargo é o conjunto de permissões e de áreas que o usuário herda (Samuel,
      // 15/10/2026). Mesma permissão de Usuários, como sempre foi.
      { label: 'Cargos', labelKey: 'nav.positions', path: '/administrativo/cargos', icon: BadgeCheck, ready: true, matchNested: true, permission: 'users.view' },
      // Trilha de auditoria. A permissão audit.view não entra no conjunto padrão
      // de staff_operator: é concedida caso a caso, e staff_admin passa por
      // bypass. O item some do menu para quem não tem a permissão.
      { label: 'Auditoria', labelKey: 'nav.audit', path: '/administrativo/auditoria', icon: ShieldCheck, ready: true, permission: 'audit.view' },
    ],
  },
]
